import { Flex, styled } from '@grupoboticario/flora-react';

const styles = {
  SectionWrapper: styled('div', {
    background: '$backgroundPrimary',

    '&:last-child': {
      marginBottom: '$4',
    },
  }),

  SkeletonWrapper: styled(Flex, {
    padding: '$10 0',
  }),

  Wrapper: styled(Flex, {
    position: 'relative',
    zIndex: 0,
  }),
};

export default styles;
